export default ({ instance, baseURL, headers }) => {
    const apiCalls = {
        getPerfisPortal() {
            return instance({
                method: 'get',
                baseURL,
                url: 'PerfilPortal/ListarPerfilPortal',
                responseType: 'json',
                headers: headers,
            });
        },
        getTelaPerfisPortal() {
            return instance({
                method: 'get',
                baseURL,
                url: 'PerfilPortal/ListarTelaPerfilPortal',
                responseType: 'json',
                headers: headers,
            });
        },
    }
    return apiCalls;
};